import { Query, QueryHandler, RootContextBase } from '@skylab-shared/core';
import { PaymentMethodBaseQuery, PaymentMethodItem } from './payment-method-base.query-base';

export class PaymentMethodQuery extends Query<PaymentMethodItem[]> { }

export class PaymentMethodQueryHandlerBase implements QueryHandler<PaymentMethodQuery, PaymentMethodItem[]> {
    public constructor(
        private readonly rootContext: RootContextBase
    ) {}

    public async handleAsync(_: PaymentMethodQuery): Promise<PaymentMethodItem[]> {
        const data = await this.rootContext.getAsync(PaymentMethodBaseQuery);
        return data.filter(elem => elem.name !== 'Inna'); //TODO: do zmiany jak z BE przyjdzie jakaś konkretna flaga
    }
}
